import { axiosPrivate } from ".";
import store from "../store";

export const getStore = () => {
  const { sequenciador } = store.getters.storeInfo;

  return sequenciador;
};

export const getOrderEvents = params =>
  axiosPrivate.post(
    `listar/ordenacao`,
    {
      tipo: "wl",
      sequenciador: getStore(),
      ...params,
    },
    {
      cache: true,
    }
  );

export const getOrderEventsMktp = params =>
  axiosPrivate.post(
    `listar/ordenacao`,
    {
      tipo: "mktp",
      ...params,
    },
    {
      cache: true,
    }
  );

export const reorderEventsEcommerce = params =>
  axiosPrivate.post(
    `loja/produto/reordenarVenda`,
    {
      loja: getStore(),
      tipo: "wl",
      ...params,
    },
    {
      cache: true,
    }
  );

export const reorderEventsMktp = params =>
  axiosPrivate.post(
    `loja/produto/reordenarVenda`,
    {
      tipo: "mktp",
      ...params,
    },
    {
      cache: true,
    }
  );
